import { Navigate, Outlet } from "react-router";
import { usePortalSettings } from "../api/hooks/usePortalSettings";
import { routePaths } from "./route-paths";

/** The membership pages, or the dashboard where memberships are hidden, including for a saved link. */
export function RequireMemberships() {
  const settings = usePortalSettings();

  if (settings.isPending) {
    return null;
  }

  return settings.data?.membershipsEnabled ? (
    <Outlet />
  ) : (
    <Navigate to={routePaths.dashboard} replace />
  );
}
